module.exports = __webpack_public_path__ + "img/SignBackground.93a287c0.svg";